import React from "react";
import styled from "styled-components";
// Screenshots
import telegramLogo from "../assets/img/anleitung/Telegram_logo.svg.webp";
import screenshot1 from "../assets/img/anleitung/1.jpg";
import screenshot2 from "../assets/img/anleitung/2.jpg";
import screenshot3 from "../assets/img/anleitung/3.jpg";
import screenshot4 from "../assets/img/anleitung/4.jpg";
import screenshot5 from "../assets/img/anleitung/5.jpg";
import screenshot6 from "../assets/img/anleitung/6.jpg";
import screenshot7 from "../assets/img/anleitung/7.jpg";
import screenshot8 from "../assets/img/anleitung/8.jpg";
import screenshot9 from "../assets/img/anleitung/9.jpg";
import screenshot11 from "../assets/img/anleitung/11.jpg";
import screenshot12 from "../assets/img/anleitung/12.jpg";
import screenshot13 from "../assets/img/anleitung/13.jpg";
import screenshot14 from "../assets/img/anleitung/14.jpg";
import screenshot15 from "../assets/img/anleitung/15.jpg";
import screenshot16 from "../assets/img/anleitung/16.jpg";
import screenshot17 from "../assets/img/anleitung/17.jpg";
import screenshot18 from "../assets/img/anleitung/18.jpg";
import screenshot10 from "../assets/img/anleitung/10.jpg";

export default function Anleitung() {
    return (
        <Wrapper>
            <ContentWrapper>
                <Header>
                    <Title>Anleitung: Neuer Teppich hinzufügen</Title>
                </Header>

                {/* Schritt 1: Telegram-Bild zuschneiden */}
                <Step>

                    <StepText>
                        <StepNumber>1.</StepNumber>Öffnen Sie die Telegram-App auf Ihrem Handy, fotografieren Sie den Teppich in der Gruppe "Teppich Bilder", schneiden Sie die Ränder direkt in Telegram zu und schicken Sie das zugeschnittene Bild in die Gruppe.
                    </StepText>
                    <ScreenshotContainer>
                        <Caption>Telegram-App auf Ihr Handy öffnen</Caption>
                        <Screenshot2 src={telegramLogo} alt="Telegram Icon" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Bild auswählen</Caption>
                        <Screenshot src={screenshot1} alt="Teppich in der Gruppe" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Kamerabild auswählen</Caption>
                        <Screenshot src={screenshot2} alt="Teppich in der Gruppe" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Fotogerafieren</Caption>
                        <Screenshot src={screenshot3} alt="Fotoansicht in Telegram" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Scheren-Icon antippen</Caption>
                        <Screenshot src={screenshot4} alt="Zuschneiden starten" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Scheren speichern</Caption>
                        <Screenshot src={screenshot5} alt="Zuschneiden starten" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Bild in der gruppe schicken</Caption>
                        <Screenshot src={screenshot6} alt="Zuschneiden bestätigen" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Download bestätigen</Caption>
                        <Screenshot src={screenshot7} alt="Speichern Hinweis" />
                    </ScreenshotContainer>
                </Step>

                {/* Schritt 2: Bild speichern */}
                <Step>

                    <StepText>
                        <StepNumber>2.</StepNumber>Öffnen Sie Telegram Desktop auf Ihrem PC, suchen Sie das gerade gesendete Bild, klicken Sie auf den Download-Pfeil und speichern Sie es im Ordner <code>Downloads/TelegramDesktop</code>.
                    </StepText>

                    <ScreenshotContainer>
                        <Caption>Telegram Applikation auf PC öffnen</Caption>
                        <Screenshot src={screenshot8} alt="Speichern Hinweis" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Das hochgeladenes Bild auswählen</Caption>
                        <Screenshot src={screenshot9} alt="Speichern Hinweis" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Das Bild in Downloads speichern</Caption>
                        <Screenshot src={screenshot10} alt="Speichern Hinweis" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Auf irgendwo klicken, um Das Bild schließen</Caption>
                        <Screenshot src={screenshot11} alt="Speichern Hinweis" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Teppichhaus Applikation auf PC öffnen</Caption>
                        <Screenshot src={screenshot12} alt="Telegram Desktop Icon" />
                    </ScreenshotContainer>

                </Step>

                {/* Schritt 3: Formular aufrufen */}
                <Step>

                    <StepText>
                        <StepNumber>3.</StepNumber>Öffnen Sie Ihre Teppichhaus-App auf, klicken Sie oben im Menü auf <strong>Teppiche</strong> und dann auf den grünen Button <strong>+ Neuer Teppich</strong>.
                    </StepText>
                    <ScreenshotContainer>
                        <Caption>Auf „Teppiche“ anklicken</Caption>
                        <Screenshot src={screenshot13} alt="Telegram Desktop Fenster" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Auf „Neuer Teppich“ anklicken</Caption>
                        <Screenshot src={screenshot14} alt="Menüpunkt Teppiche" />
                    </ScreenshotContainer>
                </Step>

                {/* Schritt 4: Formular ausfüllen */}
                <Step>

                    <StepText>
                        <StepNumber>4.</StepNumber>Klicken Sie im Formular auf <strong>Bilder auswählen</strong>, navigieren Sie zum Ordner <code>Downloads/TelegramDesktop</code>, wählen Sie das gespeicherte Bild aus und bestätigen Sie mit <strong>Öffnen</strong>.
                    </StepText>
                    <ScreenshotContainer>
                        <Caption>Auf „Bilder auswählen“ anklicken</Caption>
                        <Screenshot src={screenshot15} alt="Button Neuer Teppich" />
                    </ScreenshotContainer>
                    <ScreenshotContainer>
                        <Caption>Das Bild mit Doppelklick auswählen auswählen</Caption>
                        <Screenshot src={screenshot16} alt="Button Bilder auswählen" />
                    </ScreenshotContainer>

                </Step>

                {/* Schritt 5: Formular abschließen */}
                <Step>

                    <StepText>
                        <StepNumber>5.</StepNumber>Füllen Sie alle Felder aus (Name, Preise, Modell, Maße, Beschreibung). Wenn nötig, setzen Sie den Haken bei <em>Preis auf Anfrage</em>. Klicken Sie dann unten auf <strong>Hinzufügen</strong>.
                    </StepText>
                    <ScreenshotContainer>
                        <Caption>Das Formular ausfüllen und auf speichern/hinzufügen anklicken</Caption>
                        <Screenshot src={screenshot17} alt="Explorer Datei wählen" />
                    </ScreenshotContainer>
                </Step>

                {/* Schritt 6: Ergebnis prüfen */}
                <Step>

                    <StepText>
                        <StepNumber>6.</StepNumber>Prüfen Sie in der Teppich-Übersicht, ob Ihr neuer Teppich mit Bild, Objekt-Nr. und Preis korrekt angezeigt wird.
                    </StepText>
                    <ScreenshotContainer>
                        <Caption>Der Teppich wurde gespeichert</Caption>
                        <Screenshot src={screenshot18} alt="Button Hinzufügen" />
                    </ScreenshotContainer>

                </Step>

                {/*<Signature>Bei Fragen: Ihr Administrator-Team</Signature>*/}
            </ContentWrapper>
        </Wrapper>
    );
}

const Wrapper = styled.section`
  padding-top: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  background-color: #f3f3f3;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: bold;
`;

const Step = styled.div`
  margin-bottom: 20px;
`;

const StepNumber = styled.span`
  font-weight: bold;
  margin-right: 10px;
`;

const StepText = styled.p`
  font-size: 18px;
  margin: 5px 0;
`;

const ScreenshotContainer = styled.div`
  margin-top: 20px;
  text-align: center;
`;

const Screenshot = styled.img`
  //width: 100%;
  max-width: 600px;
  max-height: 600px;
  border: 1px solid #ccc;
  border-radius: 4px;
  @media (max-width: 760px) {
    max-width: 320px;
  }
`;
const Screenshot2 = styled.img`
  //width: 100%;
  //max-width: 600px;
  max-height: 60px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const Caption = styled.p`
  font-size: 18px;
  margin: 5px 0;
  color: #333;
`;

const Signature = styled.p`
  margin-top: 30px;
  text-align: right;
  font-weight: bold;
`;
